export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Cyrillic-92086fc1b9953ba20acd3e8584d8e897.woff";